import React from "react";
import { createUseStyles } from "react-jss";
import { RichTextField } from "../common/richTextField/RichTextField";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";
import { TextField } from "@mui/material";

const useStyles = createUseStyles({
  pullQuoteWrapper: {
    margin: "12px 0",
    paddingLeft: "16px",
    borderLeft: "4px solid #4484F1",
    fontStyle: "italic",
  },
  authorField: {
    marginTop: "8px",
    width: "100%",
  },
});

export const EditTextBlock = ({
  isActiveBlock,
  text,
  placeholder,
  isPullQuote,
  quoteAuthor,
  onUpdate,
  onTogglePullQuote,
  children,
}) => {
  const classes = useStyles();
  const tHook = useScrollytellTranslation();
  const t = typeof tHook === "function" ? tHook : (k, fb) => fb || k;

  const handleUpdate = (rawText) => {
    onUpdate("text", JSON.stringify(rawText));
  };

  const handleAuthorChange = (e) => {
    onUpdate("quoteAuthor", e.target.value);
  };

  const content = (
    <RichTextField
      showToolbar={isActiveBlock}
      value={text}
      onChange={handleUpdate}
      placeholder={placeholder || t("editTextPlaceholder", "Skriv din tekst her...")}
      onTogglePullQuote={onTogglePullQuote}
      isPullQuote={isPullQuote}
    />
  );

  return (
    <>
      {isPullQuote ? (
        <div className={classes.pullQuoteWrapper}>
          {content}
          {isActiveBlock && (
            <TextField
              size="small"
              variant="standard"
              placeholder={t("editText.authorPlaceholder", "Sitatkilde / forfatter (valgfritt)")}
              inputProps={{ "aria-label": t("editText.authorLabel", "Sitatkilde / forfatter") }}
              value={quoteAuthor || ""}
              onChange={handleAuthorChange}
              className={classes.authorField}
            />
          )}
        </div>
      ) : (
        content
      )}
      {children}
    </>
  );
};
